import { call, put, takeLatest } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { errorHandler } from '../../core/helpers/errorHelpers'

import { searchCandidateSkills } from '../../core/apiModules/candidateSkills'

import * as topSkillsView from '../reducks/topSkills'
import * as topSkillsApi from '../apiModules/topSkills'

function* fetchTopSkillsSaga({ payload }) {
  try {
    const response = yield topSkillsApi.fetchTopSkills(payload.id)
    yield put(topSkillsView.fetchTopSkillsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(topSkillsView.fetchTopSkillsError(error))
  }
}

function* updateTopSkillsSaga({ meta, payload }) {
  try {
    const response = yield topSkillsApi.updateTopSkills(payload.id, payload.data)
    yield put(topSkillsView.updateTopSkillsSuccess(response))
    yield call(meta.resolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(topSkillsView.updateTopSkillsError(error))
    yield call(meta.reject, new SubmissionError({ _error: error }))
  }
}

function* searchTopSkillsSaga({ payload }) {
  try {
    const response = yield searchCandidateSkills(payload.text)
    yield put(topSkillsView.searchTopSkillsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(topSkillsView.searchTopSkillsError(error))
  }
}

export default function* watchTopSkillsSaga() {
  yield takeLatest(topSkillsView.FETCH, fetchTopSkillsSaga)
  yield takeLatest(topSkillsView.SEARCH, searchTopSkillsSaga)
  yield takeLatest(topSkillsView.UPDATE, updateTopSkillsSaga)
}
